import * as React from 'react'
import { useCallback, useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { deleteUser, retrieveLoggedInUser, storeLoggedInUser } from '../LocalStorage'

export const AppContext = React.createContext(null)

const AppProvider = ({ children }) => {
  const [toast, addToast] = useState(0)
  const [user, setUser] = useState(retrieveLoggedInUser())

  const loadUserFromStorage = useCallback(() => {
    setUser(retrieveLoggedInUser())
  }, [])

  const storeUser = useCallback(
    (user) => {
      storeLoggedInUser(user)
      loadUserFromStorage()
    },
    [loadUserFromStorage],
  )

  const onLogout = useCallback(() => {
    deleteUser()
    loadUserFromStorage()
  }, [loadUserFromStorage])

  const setRegistered = useCallback(() => {
    const newState = {
      ...user,
      data: {
        ...user?.data,
        registrationCompleted: true,
      },
    }
    storeUser(newState)
  }, [user, storeUser])

  const value = {
    toast,
    addToast,
    loadUserFromStorage,
    user,
    storeUser,
    setRegistered,
    onLogout,
  }

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export const useAppContext = () => useContext(AppContext)

AppProvider.propTypes = {
  children: PropTypes.element,
}

export default AppProvider
